import type { SystemStyleObject } from "@chakra-ui/react"

export const chakraStyles = {
  default: {
    input: (base: SystemStyleObject) => ({
      ...base,
      py: "1",
    }),
  },
  outline: {
    control: (base: SystemStyleObject) => ({
      ...base,
      border: "1px solid",
      borderColor: "lineStrong",
      borderRadius: "sm",
    }),
    input: (base: SystemStyleObject) => ({
      ...base,
      py: "1",
    }),
    inputContainer: (base: SystemStyleObject) => ({
      ...base,
      "padding-top": "0",
      "padding-bottom": "0",
    }),
    valueContainer: (base: SystemStyleObject) => ({
      ...base,
      "padding-inline-start": "var(--chakra-space-6)",
      "padding-inline-end": "var(--chakra-space-6)",
      "padding-top": "var(--chakra-space-3-5)",
      "padding-bottom": "var(--chakra-space-3-5)",
      "font-size": "var(--chakra-fontSizes-md)",
    }),
    placeholder: (base: SystemStyleObject) => ({
      ...base,
      color: "var(--chakra-colors-textSubtle)",
    }),
    dropdownIndicator: (base: SystemStyleObject) => ({
      ...base,
      color: "textMuted",
    }),
    menu: (base: SystemStyleObject) => ({
      ...base,
      zIndex: 10,
    }),
  },
}

export type Variant = keyof typeof chakraStyles

export const getChakraStyles = (styleVariant: string | Variant) => {
  return chakraStyles[styleVariant as Variant] ?? chakraStyles.default
}
